import React, { useEffect, useState } from "react";
import { ROUTES } from "../../../../constant/routeConstant";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { GROLOG_URL } from "../../../../constant/apiConstant";
import { AutoComplete, Input, Spin, Tooltip } from "antd";
import style from "../TemperatureCategory.module.css";
import { AscRed, CloseIconSearch, DeleteIcon, DescGrey, DetailIcon, EditIcon, SearchIcon } from "../../../../asset";
import Delete from "../../../../component/modal/ModalDelete";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import CustomTable from "../../../../component/table/CustomTable";
import CustomPaging from "../../../../component/pagination/pagination";
import { AddIcon } from "../../../../asset/icons";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import { useSelector } from "react-redux";
import * as TemperatureServices from '../../../../service/setup/TemperatureCategory/TemperatureCategoryService';

const ListTemperatureCategory = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  
  const navigate = useNavigate();
  const location = useLocation();
  
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  
  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [sorting, setSorting] = useState("asc");
  const [sortingName, setSortingName] = useState("asc");
  const [sortingDesc, setSortingDesc] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] = useState()
  const [loading, setLoading] = useState(false)
  const [isFilter, setIsfilter] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    getList(page, limit);

    // eslint-disable-next-line
  },[page, limit]);

  const getList = async (page, limit, order, filter) => {
    const { ok, list } = await TemperatureServices.getList(token, page, limit, order, filter);

    if (ok) {
      setList(list)
    }
  }

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {

    const api = GROLOG_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  }

  const fetchData = async (page, limit, data, sort) => {
    setLoading(true)
    let tkn = token;  
    let res = await doGet(
      `/temperature-category?page=${page}&limit=${limit}&order=code ${sort ? sort : sorting}${!isFilter
        ? ""
        : filter ? "&filter=name lk " + filter : data ? "&filter=name lk " + data : ""}&${param}`,
      tkn
    );
    let init = await doGet(
      `/temperature-category/initiate?page=${page}&limit=${limit}&order=code ${sort ? sort : sorting}${!isFilter
        ? "" : filter ? "&filter=name lk " + filter : data ? "&filter=name lk " + data : ""}&${param}`,
      tkn
    );
    setListData(res?.data?.payload?.data);
    if (init?.data?.payload?.data) {
      setInitiate(init?.data?.payload?.data);
    } else { }
    setListData(res?.data?.payload?.data);
    setLoading(false)
    setFilter(false)
  }

  useEffect(() => {
    fetchData(page, limit);
    // eslint-disable-next-line
  }, [page, limit, data]);

  const handleEdit = (id) => {
    navigate(ROUTES.TEMPERATURE_CATEGORY.EDIT, { state: { id , prevPage: location?.pathname } });
  }

  const handleDetail = (id) => {
    navigate(ROUTES.TEMPERATURE_CATEGORY.DETAIL, { state: { id , prevPage: location?.pathname } });
  }

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  }

  const dataSource = listData
    ? listData.map((result) => ({
      name: (
        <span className="font-roboto text-lg text-[#222222]">
          {result?.name ? result?.name : '-'}
        </span>
      ),

      code: (
        <span className="font-roboto text-lg text-[#222222]">
          {result?.code_name ? result?.code_name : '-'}
        </span>
      ),
      desc: (
        <span className="font-roboto text-lg text-[#222222]">
          {result?.description ? result?.description : '-'}
        </span>
      ),
      action: (
        <div className="flex gap-[26px]">
          <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
            <button onClick={() => handleEdit(result?.temperature_category_id)}>
              <img src={EditIcon} alt="edit" />
            </button>
          </Tooltip>
          <Tooltip title={t("Delete")} color="#CF0000">
            <button onClick={() => setModal(result)}>
              <img src={DeleteIcon} alt="del" />
            </button>
          </Tooltip>

          <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
            <button
              onClick={() => handleDetail(result?.temperature_category_id)}
            >
              <img src={DetailIcon} alt="det" />
            </button>
          </Tooltip>
        </div>
      ),
    })) : null;

  const doSort = async (sort) => {
    setSorting(sort);

    if (sort) {
      setSorting(sort);
      fetchData(1,10,data, sort);
    }
  }

  const doSortName = async (sort) => {
    setSortingName(sort);

    if (sort) {
      setSortingName(sort);
      fetchData(1,10,data, sort);
    }
  }

  const doSortDesc = async (sort) => {
    setSortingDesc(sort);

    if (sort) {
      setSortingDesc(sort);
      fetchData(1,10,data, sort);
    }
  }

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("TEMPERATURE_CATEGORY:TBL_CATEGORY_NAME")}
            </span>
          </div>
          <div style={{ marginTop: "3px", marginLeft: '10px' }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("asc");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={sorting === "asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("desc");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      render: (name) => <span>{name}</span>,
    },

    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("TEMPERATURE_CATEGORY:TBL_CATEGORY_CODE")}
            </span>
          </div>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sortingName === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={sortingName === "asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSortName("asc");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sortingName === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={sortingName === "asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSortName("desc");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "code",
      key: "code",
      render: (code) => <span>{code}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("TEMPERATURE_CATEGORY:TBL_DESC")}
            </span>
          </div>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sortingDesc === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={sortingDesc === "asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSortDesc("asc");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sortingDesc === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={sortingDesc === "asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSortDesc("desc");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "desc",
      key: "desc",
      render: (desc) => <span>{desc}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMMON:ACTION")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {

    }
  }

  const fetchRecommendation = async ( page, limit, filters) => {
    if (filters.length >= 1) {
      let tkn = token;
      let res = await doGet(`/temperature-category/search?page=${page}&limit=${limit}&filter=name lk ${filters}`, tkn);
      setListRecommendation(res?.data?.payload?.data);
    }
  }

  const onSearchRecommendation = async (value) => {
    setIsfilter(true)
    setSearchRecommedation(value)
    if (value) {
      setSearchRecommedation(value)
      await fetchRecommendation(1, 10, value)
    }
  }

  const onSelectRecommendation = (data) => {
    setIsfilter(true)
    setFilter(data)
    fetchData(1,10,data)
  }

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    setPage(1)

    fetchData(1,10,"");
  }

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  return (
    <>
      <Delete
        data={data.updated_at}
        id={data.temperature_category_id}
        delete={showDelete}
        title={data?.name}
        url={"temperature-category"}
        action={() => setShowDelete(false)}
        route={ROUTES.TEMPERATURE_CATEGORY.LIST}
        refresh={() => fetchData(1,10)}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Temperature Category`}
        />

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Temperature Category")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <AutoComplete
            options={options}
            value={searchRecommendation}
            onChange={(value) => onSearchRecommendation(value)}
            onSelect={(value) => onSelectRecommendation(value)}
          >
            <Input
              placeholder={t("Search Temperature Name")}
              className="w-[350px] h-[47px]"
              height={47}
              width={350}
              suffix={
                <img
                  src={searchRecommendation ? CloseIconSearch : SearchIcon}
                  alt="search"
                  onClick={searchRecommendation ? () => onClearRecommendation() : null}
                />
              }

              value={searchRecommendation}
            />
          </AutoComplete>
          <Link to={ROUTES.TEMPERATURE_CATEGORY.ADD}>
            <PrimaryButton
              text={t("Add Temperature Category")}
              prefixIcon={<AddIcon />}
            />
          </Link>
        </div>

        {
          !loading ?
            <div className={style.tableContainer}>
              <CustomTable columns={ListColumn} data={dataSource} />
              <div className={style.containerPagination + " mt-[-45px]"}>
                <CustomPaging
                  idLimit="ddlrowsperpagetemperaturecategory"
                  idPagination="btnpaginationtemperaturecategory"
                  size="small"
                  current={page}
                  defaultCurrent={page}
                  pageSize={limit}
                  total={initiate && initiate?.count_data}
                  pageSizeOptions={initiate && initiate?.valid_limit}
                  onShowSizeChange={() => handlePagination()}
                  handlePaging={(a, b) => handlePagination(a, b)}
                  title={t("COMMON:ROW_PAGE")}
                />
              </div>
            </div>
            : (<Spin />)
            }
      </div>
    </>
  );
}

export default ListTemperatureCategory;
